import React from 'react';

import { TYPE_SYSTEM_MESSAGE } from 'App/components/News/constants';
import { loadTypes } from 'App/components/News/sources/news';

import {
  Grid,
  IconButton,
  Typography,
  HighlightOffIcon,
} from '@gogame/components';
import { FormField, withForm, SidePageV2 } from '@gogame/form';

import { LEFT_DRAWER_Z_INDEX } from '../../../Sidebar/constants';
import ExpirationDateWithTime from './ExpirationDateWithTime';
import NewsPreview from './NewsPreview';
import TypesRadioGroup from './NewsTypes';
import {
  TYPE,
  EXPIRATION_DATE,
  TAB_EDITOR,
  TAB_PREVIEW,
  NOTIFY_BY_EMAIL,
  TEXT,
} from './constants';
import { newsFormValidationSchema } from './schemas';

const NewsForm = withForm({
  validationSchema: newsFormValidationSchema,
  enableReinitialize: true,
})(
  ({
    children,
    title,
    loading,
    onClose,
    onExited,
    open,
    values,
    setFieldValue,
    isCreate,
  }) => {
    const typeId = values[TYPE];

    const showExpirationDate = typeId === TYPE_SYSTEM_MESSAGE;

    const handleClearExpirationDate = React.useCallback(() => {
      setFieldValue(EXPIRATION_DATE, undefined);
    }, []);

    return (
      <SidePageV2
        onClose={onClose}
        onExited={onExited}
        loading={loading}
        open={open}
        size={'md'}
        direction={'right'}
        directionOfset={'64px'}
        zIndex={LEFT_DRAWER_Z_INDEX}
      >
        <SidePageV2.Title title={title} />
        <SidePageV2.Tabs activeTabId={TAB_EDITOR}>
          <SidePageV2.Tab label={TAB_EDITOR}>
            <SidePageV2.Content loading={loading}>
              <Grid container spacing={3}>
                <Grid item xs={6}>
                  <TypesRadioGroup
                    title={'News type'}
                    source={loadTypes}
                    name={TYPE}
                    padding={0}
                  />
                </Grid>
                {isCreate ? (
                  <Grid item xs={6}>
                    <Typography variant={'caption'} color={'textSecondary'}>
                      Posting settings
                    </Typography>
                    <FormField.Checkbox
                      label={'Notify users by email'}
                      name={NOTIFY_BY_EMAIL}
                      padding={0}
                    />
                  </Grid>
                ) : null}
                {showExpirationDate ? (
                  <Grid item container xs={12} spacing={2}>
                    <Grid item xs={4}>
                      <FormField.DatePicker
                        name={EXPIRATION_DATE}
                        label={'Warning message expiration date'}
                        padding={0}
                      />
                    </Grid>
                    <Grid item xs={3}>
                      <ExpirationDateWithTime />
                    </Grid>
                    {values[EXPIRATION_DATE] ? (
                      <Grid item>
                        <IconButton
                          icon={<HighlightOffIcon />}
                          tooltip={'Clear'}
                          onClick={handleClearExpirationDate}
                        />
                      </Grid>
                    ) : null}
                  </Grid>
                ) : null}
                <Grid item xs={12}>
                  <FormField.MarkdownRichText
                    padding={0}
                    placeholder={'News text'}
                    name={TEXT}
                    autofocus={true}
                  />
                </Grid>
              </Grid>
            </SidePageV2.Content>
          </SidePageV2.Tab>
          <SidePageV2.Tab label={TAB_PREVIEW}>
            <SidePageV2.Content loading={loading}>
              <NewsPreview data={values} />
            </SidePageV2.Content>
          </SidePageV2.Tab>
        </SidePageV2.Tabs>
        <SidePageV2.Actions>
          <SidePageV2.CloseButton />
          <SidePageV2.SubmitButton />
        </SidePageV2.Actions>
        {children}
      </SidePageV2>
    );
  }
);

export default NewsForm;
